var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"market-page container"},[_c('market-header',{attrs:{"tab-base-url":"/shop-goods/goods"}}),_c('market-extras')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }